export const markdown_faq_27_1 = `Nel caso l'attività sia stata svolta per conto di un Ente gestore, una volta terminato il proprio incarico è possibile **consegnare i risultati al committente anche in formato informatizzato**.

Ricordiamo che all'intetno delle Linee Guida Ponti si fa espressamente riferimento alla necessità che le informazioni relative al patrimonio siano in formato digitale.

Per chiudere l'attività e trasmetterla, in corrispondenza dell'attività o all'interno dell'attività stessa, selezionare il tasto *Consegna e Archivia*.`;
export const markdown_faq_27_2 = `Nel pannello di consegna:
1. Inserire i dati dell'Ente destinatario (precompilati nel caso ci sia già un Ente associato al ponte o all'attività) 
2. Selezionare *Consegna e archivia*.`;
